import React from 'react';
import * as Sentry from '@sentry/react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    Sentry.captureException(error, { extra: errorInfo });
    console.error('[ErrorBoundary]', error, errorInfo.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh', display: 'flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center',
          fontFamily: 'sans-serif', padding: '2rem', textAlign: 'center',
          background: '#faf9ff'
        }}>
          <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🌙</div>
          <h1 style={{ fontSize: '1.5rem', color: '#1e1b4b', marginBottom: '0.5rem' }}>
            Something went wrong
          </h1>
          {/* Hardcoded, not var(--text-muted2): this screen sets its own light
              background, and in dark mode that token is #b0a0d0 — 2.28:1 against
              #faf9ff, about half the WCAG AA minimum, so the one line telling the
              user what to do was barely legible. A last-resort error screen also
              has to render correctly when the theme system is the thing that
              broke, which means it cannot depend on CSS variables at all. */}
          <p style={{ color: '#555555', marginBottom: '1.5rem', maxWidth: 400 }}>
            We hit an unexpected snag. Please refresh the page — your stories are safe.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: '0.6rem 1.4rem', background: '#7c3aed', color: '#fff',
              border: 'none', borderRadius: '0.5rem', cursor: 'pointer', fontSize: '1rem'
            }}
          >
            Refresh page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
